module.exports = __webpack_public_path__ + "img/10th_life-skills.c57ae759.webp";